import React from 'react';
import { cn } from '../lib/utils'; // Assuming standard utils, but I'll inline the helper if utils doesn't exist or just use template literals
import { motion } from 'framer-motion';
interface ChatBubbleProps {
  message: string;
  isOutgoing?: boolean;
  timestamp?: string;
  className?: string;
}
export function ChatBubble({
  message,
  isOutgoing = false,
  timestamp,
  className
}: ChatBubbleProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className={`flex w-full ${isOutgoing ? 'justify-end' : 'justify-start'} mb-2 ${className || ''}`} data-id="element-26">
      <div className={`
          relative max-w-[85%] px-4 py-2 rounded-lg text-sm md:text-base shadow-sm
          ${isOutgoing ? 'bg-[#005c4b] text-white rounded-tr-none' : 'bg-[#202c33] text-white rounded-tl-none'}
        `} data-id="element-27">
        {/* Tail */}
        <div className={`absolute top-0 w-0 h-0 border-[6px] border-transparent 
            ${isOutgoing ? '-right-[6px] border-t-[#005c4b] border-l-[#005c4b]' : '-left-[6px] border-t-[#202c33] border-r-[#202c33]'}
          `} data-id="element-28" />

        <p className="leading-relaxed whitespace-pre-wrap" data-id="element-29">{message}</p>

        {timestamp && <div className={`text-[10px] mt-1 text-right ${isOutgoing ? 'text-green-100/70' : 'text-gray-400'}`} data-id="element-30">
            {timestamp}
          </div>}
      </div>
    </motion.div>;
}